import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getLatestTelemetric = createAsyncThunk('violationSlice/getViolations', async () => {
    try {
        let response = await axios.get('/latest-telemetric-data', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const telemetricSlice = createSlice({
    name: 'telemetricSlice',
    initialState: {
        data: []
    },

    extraReducers: (builder) => {
        builder.addCase(getLatestTelemetric.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
    }
});

export default telemetricSlice.reducer;
